// extracted by mini-css-extract-plugin
module.exports = {"optional-field-label":"EditForm_optional-field-label__2INl4","create-or-request-card-steps__input-label":"EditForm_create-or-request-card-steps__input-label__3nTNQ"};